import Menu from "@/components/Common/Menu/Menu";
import {
  useOnTouchMovellLock,
  useOnWheellLock,
} from "@/hooks/usePreventEventSliding";
import { sidebarStore } from "@/stores/sidebar.ts";
import "@/styles/motion/slide.css";

export default function Sidebar() {
  return (
    <div
      class="sidebarSlideBezier flex max-h-[100%] w-[60px] shrink-0 flex-col overflow-y-auto overflow-x-hidden rounded-lg bg-[var(--colors-surface-bg-9)] transition-[width] duration-300"
      classList={{
        "!w-[236px]  ": sidebarStore.state.isExpanded,
      }}
      onWheel={(e) => useOnWheellLock(e)}
      onTouchMove={(e) => useOnTouchMovellLock(e)}
    >
      <div
        class="w-[60px] shrink-0 p-1"
        classList={{
          "!w-[236px] !p-2": sidebarStore.state.isExpanded,
        }}
      >
        <Menu />
      </div>
    </div>
  );
}
